import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/cart")({
  head: () => ({
    meta: [
      { title: "Shopping Cart | BAZZAR 3D" },
      { name: "description", content: "Review your items and complete your purchase." },
    ],
  }),
  component: lazyRouteComponent(() => import("@/pages-lazy/cart")),
});